import styles from "./LoadingIcon.module.scss"

import reloadImage from "@/lib/images/reload.svg"

type Props = {
	width?: number
}

const LoadingIcon = (props: Props) => {
	const width = props.width ?? 70
	return (
		<img
			src={reloadImage}
			alt="sync"
			style={{ width: width }}
			className={styles.loading_icon}
		/>
	)
}

export default LoadingIcon
